<template>
  <component
    :is="clickable ? BaseLink : 'div'"
    ref="elementRef"
    class="m-1 min-h-10 flex center py-2 c-$c"
    :class="{ 'hover:c-$ch underlined duration': clickable }"
    :data-cta="targets[0]?.delocalizedTracking"
    style="width: 98%;"
    :style="{
      '--c': textColor,
      '--ch': hoverLinkColor || textColor,
    }"
    :target="targets[0]?.targetAttribute"
    :to="targets[0]?.url"
    @click="handlePromotionClick"
  >
    <cms-rich-text
      class="line-clamp-2 w-full text-center container"
      :content="{ richText }"
      :links-hover-color="hoverLinkColor || textColor"
    />
  </component>
</template>

<script lang="ts" setup>
import type { Message, PromoBarColors } from '#types/components/cms/promo-bar'
import { BaseLink } from '#components'

const { content } = defineProps<{
  content: Message
}>()

const { elementRef, handlePromotionClick } = usePromotionTracking(content.promotionTracking, content.name)

const { clickable, hoverLinkColor, richText, targets = [], textColor, background, sectionId = '', id } = content
const isLowContrast = hasHighBrightness(textColor)

const colors = useState<Record<string, PromoBarColors>>('promoBarColors', () => ({}))
colors.value[sectionId || id] = { background, textColor, hoverLinkColor, isLowContrast }
</script>
